/**
 * APIレスポンス共通形式（SRD §7.1）
 *
 * 全エンドポイントでこの形式を返す。フロントは `success` で分岐。
 */
import { z } from 'zod'

export const ApiErrorSchema = z.object({
  code: z.string(), // 例: 'PROJECT_NOT_FOUND', 'PLAN_LIMIT_EXCEEDED'
  message: z.string(),
  details: z.unknown().optional(),
})
export type ApiError = z.infer<typeof ApiErrorSchema>

export const ApiMetaSchema = z.object({
  total: z.number().int().nonnegative().optional(),
  page: z.number().int().positive().optional(),
  limit: z.number().int().positive().optional(),
})
export type ApiMeta = z.infer<typeof ApiMetaSchema>

export function apiSuccessSchema<T extends z.ZodTypeAny>(dataSchema: T) {
  return z.object({
    success: z.literal(true),
    data: dataSchema,
    meta: ApiMetaSchema.optional(),
  })
}

export const ApiFailureSchema = z.object({
  success: z.literal(false),
  error: ApiErrorSchema,
})

export type ApiResponse<T> =
  | { success: true; data: T; meta?: ApiMeta }
  | { success: false; error: ApiError }
